import { apiClient } from "../apiClient";

export const TRANG_THAI_HOC_ENDPOINT = "trang-thai-hoc";
export const trangThaiHocApi = {
    SelectAll: () => apiClient.get(`${TRANG_THAI_HOC_ENDPOINT}`),
}